import { useEffect, useState } from "react";
import RightTimeApi from "@/API";
import "@style/Admin.scss";
import Enums from "@/enums";
import CompanyDepartmentsTable from "@/elements/tables/CompanyDepartmentsTable";
import DepartmentJobsTable from "@/elements/tables/DepartmentJobsTable";
import DepartmentTestTypesTable from "@/elements/tables/DepartmentTestTypesTable";

export default function CompanyDepartmentsTab(props: { tabData: any }) {
  const { company, updateSpinner, activeTab, adminPerms } = props.tabData;
  const [data, setData] = useState<any>(null);
  const [selectedDepartmentId, setSelectedDepartmentId] = useState<number | null>(null);

  function isOnThisTab() {
    return activeTab === "departments";
  }

  useEffect(() => {
    if (isOnThisTab() && company?.departmentsEnabled) {
      loadDataAsync();
    }
  }, [activeTab, company?.id, company?.departmentsEnabled]);

  if (!isOnThisTab()) return null;

  if (!company?.departmentsEnabled) {
    return (
      <div className="companyDepartmentsTab">
        <div className="tableWrapper factTable">
          <div className="noData">Departments are not enabled for this company.</div>
        </div>
      </div>
    );
  }

  if (!adminPerms?.includes(Enums.ROLE_PERMS.CompanyMenuDepartments) &&
    !adminPerms?.includes(Enums.ROLE_PERMS.SystemAdmin)) {
    return (
      <div className="companyDepartmentsTab">
        <div className="tableWrapper factTable">
          <div className="noData">You do not have permission to view this content.</div>
        </div>
      </div>
    );
  }

  async function loadDataAsync() {
    if (!company?.id) return;
    updateSpinner(true);
    const resp = await RightTimeApi.getAsync(`/CompanyDepartmentsTab/${company.id}/list`);
    updateSpinner(false);
    if (resp?.ok && resp.jsonData) {
      setData(resp.jsonData);
      setSelectedDepartmentId((current) => {
        if (current && resp.jsonData.departments?.some((d: any) => d.id === current)) {
          return current;
        }
        return null;
      });
    }
  }

  const selectedDepartment = data?.departments?.find((d: any) => d.id === selectedDepartmentId) ?? null;

  return (
    <div className="companyDepartmentsTab">
      <div className="horizontal">
        <CompanyDepartmentsTable
          company={company}
          departments={data?.departments}
          adminPerms={adminPerms}
          refreshDepartments={loadDataAsync}
          selectedDepartmentId={selectedDepartmentId}
          onSelectDepartment={(id) => setSelectedDepartmentId(id)}
          dimensionLayout
        />
      </div>

      {selectedDepartment ? (
        <>
          <DepartmentJobsTable
            department={selectedDepartment}
            jobs={data?.jobs}
            adminPerms={adminPerms}
            refreshDepartments={loadDataAsync}
          />
          <DepartmentTestTypesTable
            department={selectedDepartment}
            testTypes={data?.testTypes}
            departmentTestTypes={data?.departmentTestTypes}
            adminPerms={adminPerms}
            refreshDepartments={loadDataAsync}
          />
        </>
      ) : null}
    </div>
  );
}
